import Billing from 'components/billing/Billing';

const BillingTab: React.FC = () => {
  return (
    <div>
      <Billing />
    </div>
  );
};

export default BillingTab; 